
import React, { useState, useEffect, Fragment } from 'react';
import { AgroHeader, AgroHeaderTabs } from 'agrofy-ui-components';
import { getTagManager, gtmUserLogged } from '../../services/gtmEvents';
import { onSearchSubmit } from '../../services/onSearchSubmit';
import { getNotifications } from '../../services/getNotifications';
import { getUserData } from '../../services/getUserData';
import SuggestionService from '../../services/SuggestionService';

const Header = props => {
  const envCountry = process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE;
  const agrofyNewsSection = process.env.AGROFY_NEWS_SECTION || window.env.AGROFY_NEWS_SECTION;
  const agrofyPaySection = process.env.AGROFY_PAY_SECTION || window.env.AGROFY_PAY_SECTION;
  const agrofyNewsUrl = process.env.AGROFY_NEWS_URL || window.env.AGROFY_NEWS_URL;
  const urlServices = process.env.URL_SERVICES || window.env.URL_SERVICES;

  const [userData, setUserData] = useState();
  const [userLoading, setUserLoading] = useState(true);
  const [notifications, setNotifications] = useState();
  const [notificationsLoading, setNotificationsLoading] = useState(true);

  useEffect(() => {
    getUserData()
      .then((data) => {
        if (data && data.hasOwnProperty('fullName')) {
          setUserData({ isLogged: true, fullName: data.fullName});
          gtmUserLogged('Si', data.id);
          setUserLoading(false);
          getNotifications()
            .then((notifData) => {
              if (notifData != null) {
                setNotifications(notifData);
                setNotificationsLoading(false);
              } else {
                setNotifications({});
                setNotificationsLoading(false);
              }
            })
            .catch((error) => {
              setNotifications({});
              setNotificationsLoading(false);
              console.error(error);
            });
        } else {
          setUserData({ isLogged: false, fullName: null });
          gtmUserLogged('No', '');
          setUserLoading(false);
        }
      })
      .catch((error) => {
        setUserData({ isLogged: false, fullName: null });
        setUserLoading(false);
        gtmUserLogged('No', '');
        console.error(error);
      });
  }, []);

  const tabs = [
    {
      active: true,
      show: true,
      url: '/',
      title: 'Agrofy',
      subtitle: 'Market',
    },
    {
      active: false,
      show: agrofyNewsSection === 'true',
      url: agrofyNewsUrl,
      title: 'Agrofy',
      subtitle: 'News',
    },
    {
      active: false,
      show: agrofyPaySection === 'true',
      url: 'https://pay.agrofy.com.ar',
      title: 'Agrofy',
      subtitle: 'Pay',
    },
  ];

  return (
    <Fragment >
      <AgroHeaderTabs 
        tabs={tabs}
        tagManager={(dataLayerEvent) => {
          getTagManager().dataLayer(dataLayerEvent);
        }}
      />
      <AgroHeader 
        baseUrl={process.env.RAZZLE_BASE_URL || window.env.RAZZLE_BASE_URL}
        loginUrlRedirect={typeof window !== 'undefined' ? encodeURI(window.location.href) : null}
        tagManager={(dataLayerEvent) => {
          getTagManager().dataLayer(dataLayerEvent)
      }}
        apiGateway={process.env.RAZZLE_API_GATEWAY_URL || window.env.RAZZLE_API_GATEWAY_URL}
        user={userData}
        language={envCountry.replace('_', '-')}
        notifications={notifications}
        loadingUser={userLoading}
        loadingNotifications={notificationsLoading}
        suggestionCallback={inputText => SuggestionService(inputText)}
        onSearchSubmit={() => onSearchSubmit()}
        urlServices={urlServices}
      />
    </Fragment>
  );
};

export default Header;
